import { useCallback, useState } from 'react';
import { Affix } from 'antd';
import './index.less';
import classNames from 'classnames';
const AlphabetSelector = ({
  offsetTop,
  value = 0,
  onChange,
}: {
  value: number;
  offsetTop?: number;
  onChange?: (value: number) => void;
}) => {
  const [selectValue, setSelectValue] = useState<number>(value || 0);
  const handleChange = useCallback(
    (val: number) => {
      setSelectValue(val);
      onChange?.(val);
      // 还有日志
    },
    [onChange],
  );

  return (
    <Affix offsetTop={offsetTop}>
      <div className="alphabetical">
        <div className="alphabetical-box">
          <div
            className={classNames('alphabetical-item alphabetical-all', {
              showAsSelected: selectValue === 0,
            })}
            onClick={() => handleChange(0)}
          >
            ALL
          </div>
          {new Array(26).fill(0).map((_, index) => (
            <div
              className={classNames('alphabetical-item', {
                showAsSelected: selectValue === index + 1,
              })}
              onClick={() => handleChange(index + 1)}
              key={String.fromCharCode(0x60 + index + 1)}
            >
              {String.fromCharCode(0x60 + index + 1)}
            </div>
          ))}
        </div>
      </div>
    </Affix>
  );
};

export default AlphabetSelector;
